import { App } from '../App';
import { appConfig as $config } from '../../app.config';
import { UI } from '../UI';
import { Common } from '../Common';
import { ExportTo } from '../ExportTo';
import { User } from '../User';
import { pdfcss } from './pdfcss';

import './scss/productapprovalshort.scss';

export const ProductApprovalShort = (function () {
  let $el = {};
  let $products = [];
  let $licensedProductId;

  let mapping = (sideImages) => {
    // process dates
    sideImages.forEach((product) => {
      product.date = moment(product.date).format($config.appFullDateFormat);
      product.details.approvalDate = moment(product.details.approvalDate).format($config.appFullDateFormat);
      product.details.submissionDate = moment(product.details.submissionDate).format($config.appFullDateFormat);

      if (product.pantones) {
        product.pantones.forEach((item) => {
          item.hexadecimalname =
            item.hexadecimal && item.hexadecimal.length > 0 ? item.hexadecimal.substr(1) : item.hexadecimal;
        });
      }

      product.iniframe = window.self !== window.top;
      $products.push(product);
    });

    return $products;
  };

  let init = (element, licensedProductId) => {
    $el = element;
    $products = [];
    $licensedProductId = licensedProductId;
    UI.block(element);

    $.when(App.ajaxData(`LicensedProductApprove/${User.accountID()}/${$licensedProductId}/short`, {})).done((res) => {
      $products = mapping(res.data.sideImages);
      pageInit();
    });
  };

  let pageInit = () => {
    let pageData = {
      ...{
        $products,
        $lang: $lang
      }
    };

    let template = require('./tmpl/productapprovalshort.hbs');
    if (window.self !== window.top && window.parent) {
      template = require('./tmpl/productapprovalpdf.hbs');
    }

    UI.page(template, pageData, false).then(() => {
      // Page Loaded INFRAME PostMessage
      onLoadMessage();

      clickHandler();
      UI.unblock($el);
    });
  };

  let clickHandler = () => {
    $('#page')
      .off()
      .on('click', '.js-product-approve', approve)
      .on('click', '.js-product-disapprove', disapprove)
      .on('click', '.js-product-export', exportToPdf);
  };

  let onLoadMessage = () => {
    if (window.self === window.top) return;
    if (window.parent) {
      let mess = {
        pageloaded: true,
        FileId: $products[0].fileId,
        fileName: Common.slugify(
          `${decodeURIComponent($products[0].artworkName)}_${decodeURIComponent($products[0].blankName)}`
        ).substring(0, 250)
      };

      window.parent.postMessage(mess, '*');
    }
  };

  let approve = () => {
    // Take any product, because approval logic currently is the same
    let product = $products[0];
    let section = product.approveItem;
    section.approved = true;
    section.comments = null;
    UI.block($el);


    $.when(App.ajaxData(`LicensedProductApprove/${User.accountID()}/${$licensedProductId}/short`, section, 'PUT')).done(
      () => {
        init($el, $licensedProductId);
      }
    );
  };

  let disapprove = () => {
    // Take any product, because approval logic currently is the same
    let product = $products[0];
    let section = product.approveItem;

    bootbox.prompt({
      size: 'medium',
      title: $lang.productApprovalShort.comments,
      value: section.comments,
      callback: function (result) {
        if (result == null) {
          return;
        }

        section.approved = false;
        section.comments = result;
        UI.block($el);
        
        $.when(
          App.ajaxData(`LicensedProductApprove/${User.accountID()}/${$licensedProductId}/short`, section, 'PUT')
        ).done(() => {
          init($el, $licensedProductId);
        });
      }
    });
  };

  let exportToPdf = () => {
    ExportTo.pdf({
      selector: '#productApprovalCard-short',
      css: pdfcss,
      filename: '$licensedProductId',
      iframeurl: document.location.href //$config.productionUrl+'/prelistings/29157a99-6dab-4cab-a293-729862fc330f/productApprovalShort'//document.location.href
    });
  };

  return {
    init,
    approve,
    disapprove
  };
})();
